/*
 * Public API Surface of ngx-youtube-player
 */

export * from './lib/ngx-youtube-player.service';
export * from './lib/ngx-youtube-player.component';
export * from './lib/ngx-youtube-player.module';
